import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-ai-button',
  standalone: true,
  templateUrl: './ai-button.component.html',
  styleUrls: ['./ai-button.component.scss']
})
export class AiButtonComponent {
  @Output() clicked = new EventEmitter<void>();
}